import React from 'react'

const CTA = () => {
  return (
    <div className='cta'>
        <a href="#contact" className='btn btn-primary'>Thông tin liên hệ</a>
    </div>
  )
}

export default CTA